import {GetBNPLOrderStatusResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/payment/service.types';

export const bnplOrderStatusMock = (
  status: 'open' | 'overdue' | 'paid' | 'unavailable' | 'nothing',
): GetBNPLOrderStatusResponse => {
  if (status === 'nothing') {
    return {};
  }
  switch (status) {
    case 'open':
      return {
        status: {
          $case: 'open',
          open: {
            status: {
              status: 'Due in 3 days',
              label: 'Payment status',
              icon: {
                url: 'https://assets.aboutstatic.com/assets/ic-info-4QDFwIW5.svg',
                description: 'info icon',
                external: false,
              },
            },
            hint: 'Payments made may take some time to be reflected here.',
            paymentHint: {
              text: 'Some kind of optional payment hint!',
              icon: {
                url: 'https://assets.aboutstatic.com/assets/ic-info-4QDFwIW5.svg',
                description: 'info icon',
                external: false,
              },
            },
            paymentDueRow: {
              dueDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000),
              label: 'Payment due date',
            },
            paymentRows: [
              {label: 'Amount paid', amount: '0,00 €'},
              {label: 'Amount left', amount: '85,00 €'},
            ],
            ctaLabel: 'Pay for kept items',
          },
        },
      };
    case 'overdue':
      return {
        status: {
          $case: 'overdue',
          overdue: {
            status: {
              status: 'Payment Overdue',
              label: 'Payment status',
              icon: {
                url: 'https://assets.aboutstatic.com/assets/ic-info-4QDFwIW5.svg',
                description: 'warning icon',
                external: false,
              },
            },
            hint: 'Your payment is overdue. Please pay as soon as possible to avoid further actions.',
            paymentDueRow: {
              dueDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
              label: 'Payment due date',
            },
            paymentRows: [
              {label: 'Amount paid', amount: '0,00 €'},
              {label: 'Amount left', amount: '85,00 €'},
            ],
            ctaLabel: 'Pay for kept items',
          },
        },
      };
    case 'paid':
      return {
        status: {
          $case: 'paid',
          paid: {
            status: {
              status: 'Payment Settled',
              label: 'Payment status',
              icon: {
                url: 'https://assets.aboutstatic.com/assets/ic-info-4QDFwIW5.svg',
                description: 'success icon',
                external: false,
              },
            },
            paymentRows: [
              {label: 'Amount paid', amount: '85,00 €'},
              {label: 'Amount left', amount: '0,00 €'},
            ],
          },
        },
      };
    case 'unavailable':
      return {
        status: {
          $case: 'unavailable',
          unavailable: {
            status: {
              status: 'In preparation',
              label: 'Payment status',
              icon: {
                url: 'https://assets.aboutstatic.com/assets/ic-info-4QDFwIW5.svg',
                description: 'info icon',
                external: false,
              },
            },
            hint: 'Once your order has been shipped, you will receive an email with instructions on how to pay.',
          },
        },
      };
  }
};
